const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M4.065 14.319a.75.75 0 0 0 .153.835l.002.002 4.249 4.249a.751.751 0 0 0 1.062-1.062l-2.967-2.967h6.184l.04-.001h2.462a3.75 3.75 0 0 0 3.75-3.75v-6.5a.75.75 0 0 0-1.5 0v6.5a2.25 2.25 0 0 1-2.25 2.25h-2.461l-.041-.001H6.564l2.967-2.967A.751.751 0 1 0 8.47 9.845l-4.25 4.249-.032.034z"/></svg>';
export {
  a as w
};
